import React from 'react';
import './appointments.css';
import { useSelector } from 'react-redux';

import AppointmentCard from '../components/cards/appointmentCard/appointmentCard';

const UpcomingAppointments = ({ activeIndex, returnSelectedAppointment }) => {
    const { cutomerAppointments } = useSelector(
        (state) => state.appointments
    );

    const handleCardClick = (index, appointment) => {
        returnSelectedAppointment(index, appointment);
    };

    return (
        <AppointmentCard
            title="Upcoming Appointments"
            length={
                cutomerAppointments?.length > 0
                    ? cutomerAppointments.length
                    : 'no '
            }
            appointments={cutomerAppointments}
            handleCardClick={handleCardClick}
            activeIndex={activeIndex}
        />
    );
};

export default UpcomingAppointments;
